import { 
  collection, addDoc, updateDoc, doc, getDocs, query, where, orderBy, Timestamp 
} from 'firebase/firestore';
import { db } from '../firebase/config';

const COLLECTION_NAME = 'documentos';

export const TIPOS_DOCUMENTO = {
  CONTRATO: 'contrato',
  IMPRONTA: 'impronta',
  FORMULARIO_TRASPASO: 'formulario_traspaso',
  INFORME_CESVI: 'informe_cesvi',
  SOAT: 'soat',
  TARJETA_PROPIEDAD: 'tarjeta_propiedad',
  OTRO: 'otro'
};


const fileToBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};


export const subirDocumento = async (casoId, file, tipoDocumento, descripcion = '') => {
  console.log('Iniciando subida a Firestore:', file.name);
  
  try {
  
    if (!casoId) {
      throw new Error('ID del caso no válido');
    }


    if (!file) {
      throw new Error('No hay archivo seleccionado');
    }

    if (file.size > 1 * 1024 * 1024) {
      throw new Error('El archivo es muy grande para Firestore. Máximo 1MB.');
    }

    console.log(' Tamaño del archivo:', (file.size / 1024).toFixed(2), 'KB');
    
   
    console.log(' Convirtiendo a Base64...');
    const base64 = await fileToBase64(file);
    console.log(' Conversión completada. Longitud:', base64.length);
    

    console.log(' Guardando en Firestore...');
    const docData = {
      casoId,
      tipo: tipoDocumento,
      nombreOriginal: file.name,
      contenido: base64,
      descripcion: descripcion || '',
      fechaSubida: Timestamp.now(),
      tamaño: file.size,
      tipoMime: file.type,
      activo: true
    };
    
    const docRef = await addDoc(collection(db, COLLECTION_NAME), docData);
    console.log(' Documento guardado con ID:', docRef.id);
    
    return { 
      id: docRef.id, 
      ...docData,
      fechaSubida: new Date()
    };
    
  } catch (error) {
    console.error(' Error:', error);
    throw new Error(error.message || 'Error al subir documento');
  }
};


export const obtenerDocumentosPorCaso = async (casoId) => {
  console.log('Buscando documentos para caso:', casoId);
  
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where("casoId", "==", casoId),
      where("activo", "==", true),
      orderBy("fechaSubida", "desc")
    );
    
    const querySnapshot = await getDocs(q);
    const documentos = querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      fechaSubida: doc.data().fechaSubida?.toDate() || new Date()
    }));
    
    console.log(` ${documentos.length} documentos encontrados`);
    return documentos;
    
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};


export const verDocumento = (contenidoBase64) => {
  try {
    const ventana = window.open();
    ventana.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Visualizador de Documento</title>
          <style>
            body { margin: 0; padding: 0; }
            iframe { width: 100%; height: 100vh; border: none; }
          </style>
        </head>
        <body>
          <iframe src="${contenidoBase64}"></iframe>
        </body>
      </html>
    `);
  } catch (error) {
    console.error('Error:', error);
    throw new Error('No se pudo abrir el documento');
  }
};


export const descargarDocumento = (contenidoBase64, nombreArchivo) => {
  try {
    const link = document.createElement('a');
    link.href = contenidoBase64;
    link.download = nombreArchivo;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error:', error);
    throw new Error('No se pudo descargar el documento');
  }
};


export const eliminarDocumento = async (id) => {
  try {
    const docRef = doc(db, COLLECTION_NAME, id);
    await updateDoc(docRef, { activo: false });
    return true;
  } catch (error) {
    console.error("Error:", error);
    throw error;
  }
};